import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import NotAuthorized from './components/NotAuthorized';

function PrivateRoute({ children, permission, permissions = [], superadminOnly = false }) {
  const { currentUser, access, loading, authError, hasPermission, isSuperadmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-500"></div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  const required = permission ? [permission] : permissions;
  if (authError || !access?.active || (superadminOnly && !isSuperadmin) || (required.length > 0 && !required.some(hasPermission))) {
    return <NotAuthorized />;
  }

  return children;
}

export default PrivateRoute;
